import Vue from 'vue'
import Router from 'vue-router'

// 1.0 2.0组件切换
const version='2.0';
if(version=='1.0'){
    var homePage = () => import('../page/homePage/homePage1') // 首页
    var seek = () => import('../page/homePage/seek1') // 首页点击搜索框
    var my = () => import('../page/my/my1')
    var headline = () => import('../page/homePage/headline1') // 首页点击新闻、文学
}else{
    var homePage = () => import('../page/homePage/homePage2')
    var seek = () => import('../page/homePage/seek2')
    var my = () => import('../page/my/my2')
    var headline = () => import('../page/homePage/headline2')
}
// 首页
const homePageNews = () => import('../page/homePage/homePageNews')
const homePageHistory = () => import('../page/homePage/homePageHistory')
const homepageNewsDetails = () => import('../page/homePage/homepageNewsDetails')
const leaveNewsMessage = () => import('../page/homePage/leaveNewsMessage')
const newsSearch = () => import('../page/homePage/newsSearch')
const city = () => import('../page/homePage/City') // 首页点击全国
const Provinces = () => import('../page/homePage/Provinces')
const homeEventHall = () => import('../page/homePage/homeEventHall')
const GlobalSection = () => import('../components/GlobalSection.vue') // 首页点击新闻

// 事件馆
const event = () => import('../page/event/event')
const eventIntro = () => import('../page/event/eventIntro')
const eventNews = () => import('../page/event/eventNews')
const eventBack = () => import('../page/event/eventBack')
const eventVictim = () => import('../page/event/eventVictim')
const eventMessage = () => import('../page/event/eventMessage')
const eventMessageReply = () => import('../page/event/eventMessageReply')
const eventLeaveMessage = () => import('../page/event/eventLeaveMessage')
const eventGift = () => import('../page/event/eventGift')
const eventAlbum = () => import('../page/event/eventAlbum')
// 馆区
const archiveArea = () => import('../page/archiveArea/archiveArea') // 首页点击纪念馆/纪念馆-更多
//测试
const ProvinceHome = () => import('../page/homePage/ProvinceHome')
const ProvinceNewsList = () => import('../page/homePage/ProvinceNewsList')

//测试
const archiveAreaNew = () => import('../page/archiveArea/archiveAreaNew')
const archiveAreaDetails = () => import('../page/archiveArea/archiveAreaDetails')
const joinPageDetails = () => import('../page/archiveArea/joinPageDetails')
const confirmCemetery = () => import('../page/archiveArea/confirmCemetery') // 对应殡仪馆信息
const confirmCemeteryMap = () => import('../page/archiveArea/confirmCemeteryMap')
const newsList = () => import('../page/archiveArea/newsList')
const newsDetails = () => import('../page/archiveArea/newsDetails')
const confirmCemeteryDetails = () => import('../page/archiveArea/confirmCemeteryDetails')
const cemeteryDetails = () => import('../page/archiveArea/cemeteryDetails')
const cemeteryInDetails = () => import('../page/archiveArea/cemeteryInDetails')
const subscribeLook = () => import('../page/archiveArea/subscribeLook')
const cemeteryMessage = () => import('../page/archiveArea/cemeteryMessage')
const leaveCemeteryMessage = () => import('../page/archiveArea/leaveCemeteryMessage')
const ArchiveMediaList = () => import('../page/archiveArea/ArchiveMediaList')
const ArchivePhoto = () => import('../page/archiveArea/ArchivePhoto')
const ArchivePhotoList = () => import('../page/archiveArea/ArchivePhotoList')

const cemeteryStore = () => import('../page/archiveArea/cemeteryStore')
const shopDetails = () => import('../page/archiveArea/shopDetails')

// 个人主页
const memorial = () => import('../page/memorial/memorial') // 首页点击更多
const personSearch = () => import('../page/memorial/personSearch') // 首页点击人物
const personDetails = () => import('../page/memorial/personDetails')
const personDetailsIntro = () => import('../page/memorial/personDetailsIntro')
const personDetailsProduction = () => import('../page/memorial/personDetailsProduction')
const contactAdmin = () => import('../page/memorial/contactAdmin')
const article = () => import('../page/memorial/article')
const wordPage = () => import('../page/memorial/wordPage')
const editAlbumAdd = () => import('../page/memorial/editAlbumAdd')
const editAlbum = () => import('../page/memorial/editAlbum')
const Album = () => import('../page/memorial/Album')
const editAlbumDel = () => import('../page/memorial/editAlbumDel')
const editAlbumRname = () => import('../page/memorial/editAlbumRname')
const editWorks = () => import('../page/memorial/editWorks')
const personDetailsFete = () => import('../page/memorial/personDetailsFete')
const leaveMessage = () => import('../page/memorial/leaveMessage')
const personMessage = () => import('../page/memorial/personMessage')
const messageReply = () => import('../page/memorial/messageReply')
const feteGift = () => import('../page/memorial/feteGift')
const friends = () => import('../page/memorial/friends')
const personVisitGrave = () => import('../page/memorial/personVisitGrave')
const example = () => import('../page/memorial/example')
const orderComment = () => import('../page/memorial/orderComment')
const orderCommentImg = () => import('../page/memorial/orderCommentImg')
const paySuccess = () => import('../page/memorial/paySuccess')
const wxpaySuccess = () => import('../page/memorial/wxpaySuccess')
const personDetailsmodelone = () => import('../page/memorial/personDetailsmodelone')
const personDetailsmodelselect = () => import('../page/memorial/personDetailsmodelselect')
const setMuseum = () => import('../page/memorial/setMuseum')
const attireMuseum = () => import('../page/memorial/attireMuseum')
const editMuseum = () => import('../page/memorial/editMuseum')
const editMan = () => import('../page/memorial/editMan')
const editLife = () => import('../page/memorial/editLife')
const editLifeTree = () => import('../page/memorial/editLifeTree')
const editPassword = () => import('../page/memorial/editPassword')
const editAdmin = () => import('../page/memorial/editAdmin')
const editAdminDetails = () => import('../page/memorial/editAdminDetails')
const changeAdminDetails = () => import('../page/memorial/changeAdminDetails')
const familyTreeAdd = () => import('../page/memorial/familyTreeAdd')
const selectSkin = () => import('../page/memorial/selectSkin')
const customerService = () => import('../page/memorial/customerService')
const manyperson = () => import('../page/memorial/manyperson')


// 登录
const login = () => import('../page/login/login')

// const loginTest = () => import('../page/login/loginTest')
const loginBinding = () => import('../page/login/loginBinding')

const register = () => import('../page/login/register')
const forgetPassword = () => import('../page/login/forgetPassword')
const photoLogin = () => import('../page/login/photoLogin')
const protocol = () => import('../page/login/protocol')
// 我的
const settings = () => import('../page/my/settings')
const passwordBinding = () => import('../page/my/passwordBinding')
const settingDetails = () => import('../page/my/settingDetails')
const centerMessage = () => import('../page/my/centerMessage')
const myMessage = () => import('../page/my/myMessage')
const answer = () => import('../page/my/answer')
const requestManage = () => import('../page/my/requestManage')
const examineManage = () => import('../page/my/examineManage')
const toManage = () => import('../page/my/toManage')
const systemMsg = () => import('../page/my/systemMsg')
const setfriends = () => import('../page/my/setfriends') // 亲友管理
const srcPage = () => import('../page/my/srcPage')
const menuPage = () => import('../page/my/menuPage')
const editFriend = () => import('../page/my/editFriend')
const attention = () => import('../page/my/attention')
const jurisdiction = () => import('../page/my/jurisdiction')
const myorder = () => import('../page/my/myorder')
const myArticle = () => import('../page/my/myArticle')
const goodsDetails = () => import('../page/my/goodsDetails')
const orderEvaluate = () => import('../page/my/orderEvaluate')
const Invitation = () => import('../page/my/Invitation')
const feedback = () => import('../page/my/feedback') // 联系我们
const aboutUs = () => import('../page/my/aboutUs') // 关于我们
const cooperation = () => import('../page/my/cooperation')
const tes = () => import('../page/memorial/tes')
const OperationManual = () => import('../page/my/OperationManual') // 使用说明
// 主题
const themes = () => import('../page/themes/themes')
//海葬馆
const seaBurial = () => import('../page/marineBurialHall/seaBurial')
const seaService = () => import('../page/marineBurialHall/seaService')
const seaQuestion = () => import('../page/marineBurialHall/seaQuestion')
const seaMessage = () => import('../page/marineBurialHall/seaMessage')
const seaNews = () => import('../page/marineBurialHall/seaNews')
const seaNewsDetails = () => import('../page/marineBurialHall/seaNewsDetails')
const seaLeaveMsg = () => import('../page/marineBurialHall/seaLeaveMsg')
const seaGift = () => import('../page/marineBurialHall/seaGift')
const seaPhoto = () => import('../page/marineBurialHall/seaPhoto')
const seaPhotoList = () => import('../page/marineBurialHall/seaPhotoList')

Vue.use(Router)

export default new Router({
    routes: [
        {path: '/', redirect: '/homePage' },
        // {
        //     path:'/homePage',
        //     component:homePage,
        //     name:'homePage',
        // },
        {
            path:'/homePage',
            component:homePage,
            name:'homePage',
            meta: {keepAlive:false,reload:false},
            children:[
                { path: '/homePageNews', component: homePageNews,name:'homePageNews'},
                { path: '/homePageHistory', component: homePageHistory,name:'homePageHistory'}
            ]
        },
        {path:'/homeEventHall',component:homeEventHall,name:'homeEventHall'},
        {path:'/GlobalSection',component:GlobalSection,name:'GlobalSection'},
        {path:'/homepageNewsDetails/:id/:wztype',component:homepageNewsDetails,name:'homepageNewsDetails',meta: {keepAlive:false}},
        {path:'/leaveNewsMessage/:nid/:wztype',component:leaveNewsMessage,name:'leaveNewsMessage',meta: {keepAlive:false}},
        {path:'/city/:type',component:city,name:'city',meta: {keepAlive:false}},
        {path:'/Provinces/:type',component:Provinces,name:'Provinces',meta: {keepAlive:false}},
        {path:'/newsSearch/:value',component:newsSearch,name:'newsSearch',meta: {keepAlive:false}},
        {path:'/seek/:type',component:seek,name:'seek',meta: {keepAlive:false}},
        {path:'/headline',component:headline,name:'headline',meta: {keepAlive:false}},
        {
            path:'/event/:id',
            component:event,
            name:'event',
            children:[
                //{ path: '', component: eventIntro,name:'eventIntro'},
                { path: 'eventIntro', component: eventIntro,name:'eventIntro'},
                { path: 'eventNews', component: eventNews,name:'eventNews'},
                { path: 'eventBack', component: eventBack,name:'eventBack'},
                { path: 'eventVictim', component: eventVictim,name:'eventVictim'}
            ]
        },
        {path:'/eventMessage/:id',component:eventMessage,name:'eventMessage'},
        {path:'/eventMessageReply/:id/:comment_id',component:eventMessageReply,name:'eventMessageReply'},
        {path:'/eventLeaveMessage/:id',component:eventLeaveMessage,name:'eventLeaveMessage'},
        {path:'/eventGift/:id',component:eventGift,name:'eventGift'},
        {path:'/eventAlbum/:id',component:eventAlbum ,name:'eventAlbum'},

        {path:'/archiveArea/:key/:value/:city',component:archiveArea,name:'archiveArea',meta: {keepAlive:true,reload:false}},
       
        {path:'/ProvinceHome/:value',component:ProvinceHome,name:'ProvinceHome',meta: {keepAlive:true}},
        {path:'/ProvinceNewsList/:value/:type',component:ProvinceNewsList,name:'ProvinceNewsList',meta: {keepAlive:true}},
        
        {path:'/archiveAreaNew/:key/:value/:city',component:archiveAreaNew,name:'archiveAreaNew',meta: {keepAlive:false}},
        {path:'/archiveAreaDetails/:id',component:archiveAreaDetails,name:'archiveAreaDetails',meta: {keepAlive:false}},
        {path:'/joinPageDetails/:id',component:joinPageDetails,name:'joinPageDetails',meta: {keepAlive:false}},
        {path:'/confirmCemetery/:id',component:confirmCemetery,name:'confirmCemetery',meta: {keepAlive:false}},
        {path:'/confirmCemeteryMap/:id',component:confirmCemeteryMap,name:'confirmCemeteryMap',meta: {keepAlive:false}},
        {path:'/newsList/:id/:cid',component:newsList,name:'newsList',meta: {keepAlive:false}},
        {path:'/newsDetails/:id',component:newsDetails,name:'newsDetails',meta: {keepAlive:false}},
        {path:'/confirmCemeteryDetails/:id',component:confirmCemeteryDetails,name:'confirmCemeteryDetails',meta: {keepAlive:false}},
        {path:'/cemeteryDetails/:id',component:cemeteryDetails,name:'cemeteryDetails',meta: {keepAlive:false}},
        {path:'/cemeteryInDetails/:id',component:cemeteryInDetails,name:'cemeteryInDetails',meta: {keepAlive:false}},
        {path:'/subscribeLook/:id',component:subscribeLook,name:'subscribeLook',meta: {keepAlive:false}},
        {path:'/cemeteryMessage/:id',component:cemeteryMessage,name:'cemeteryMessage',meta: {keepAlive:false}},
        {path:'/leaveCemeteryMessage/:id',component:leaveCemeteryMessage,name:'leaveCemeteryMessage',meta: {keepAlive:false}},
        {path:'/ArchiveMediaList/:id',component:ArchiveMediaList,name:'ArchiveMediaList',meta: {keepAlive:false}},
        {path:'/ArchivePhoto/:id',component:ArchivePhoto,name:'ArchivePhoto',meta: {keepAlive:false}},
        {path:'/ArchivePhotoList/:id',component:ArchivePhotoList,name:'ArchivePhotoList',meta: {keepAlive:false}},

        {path:'/memorial/:key', component:memorial, name:'memorial',meta: {keepAlive:false}},
        {path:'/cooperation',component:cooperation,name:'cooperation',meta: {keepAlive:false}},

        {path:'/personSearch/:sjid/:value/:name',component:personSearch ,name:'personSearch',meta: {keepAlive:false}},
        {
            path:'/personDetails/:id',
            component:personDetails,
            name:'personDetails',
            children:[
                { path: 'intro', component: personDetailsIntro,name:'intro'},
                { path: 'production', component: personDetailsProduction,name:'production'},
                { path: 'fete', component: personDetailsFete,name:'fete'}
            ]
        },
        {path:'/contactAdmin/:id',component:contactAdmin,name:'contactAdmin',meta: {keepAlive:false}},
        {path:'/editAlbumAdd/:guanId/:typeid',component:editAlbumAdd ,name:'editAlbumAdd',meta: {keepAlive:false}},
        {path:'/editAlbum/:guanId/:photoId/:editFlag',component:editAlbum ,name:'editAlbum',meta: {keepAlive:false}},
        {path:'/Album/:guanId',component:Album ,name:'Album',meta: {keepAlive:false}},
        {path:'/editAlbumDel/:guanId/:photoId',component:editAlbumDel ,name:'editAlbumDel',meta: {keepAlive:false}},
        {path:'/editAlbumRname/:guanId/:photoId',component:editAlbumRname,name:'editAlbumRname',meta: {keepAlive:false}},
        {path:'/article/:guanId/:typeid/:pid',component:article,name:'article',meta: {keepAlive:false}},
        {path:'/wordPage/:pid',component:wordPage,name:'wordPage',meta: {keepAlive:false}},
        {path:'/editWorks/:guanId/:pid/:typeid',component:editWorks ,name:'editWorks',meta: {keepAlive:false}},
        {path:'/leaveMessage/:id/:modelflag',component:leaveMessage,name:'leaveMessage',meta: {keepAlive:false}},
        {path:'/personMessage/:guanId/:modelflag',component:personMessage,name:'personMessage',meta: {keepAlive:false}},
        {path:'/messageReply/:id/:coumentid',component:messageReply,name:'messageReply',meta: {keepAlive:false}},
        {path:'/feteGift',component:feteGift,meta: {keepAlive:false}},
        {path:'/friends/:id',component:friends,name:'friends',meta: {keepAlive:false}},
        {path:'/personVisitGrave/:name/:guanId',component:personVisitGrave,name:'personVisitGrave',meta: {keepAlive:false}},
        {path:'/example',component:example,name:'example',meta: {keepAlive:false}},
        {path:'/orderComment/:snow',component:orderComment,name:'orderComment',meta: {keepAlive:false}},
        {path:'/orderCommentImg/:snow',component:orderCommentImg,name:'orderCommentImg',meta: {keepAlive:false}},

        {path:'/paySuccess',component:paySuccess,name:'paySuccess',meta: {keepAlive:false}},
        {path:'/wxpaySuccess',component:wxpaySuccess,name:'wxpaySuccess',meta: {keepAlive:false}},
        {path:'/setMuseum/:id/:lyName',component:setMuseum,name:'setMuseum',meta: {keepAlive:false}},
        {path:'/attireMuseum/:guanId/:photoId',component:attireMuseum ,name:'attireMuseum',meta: {keepAlive:false}},
        {path:'/editMuseum/:guanId',component:editMuseum ,name:'editMuseum',meta: {keepAlive:false}},
        {path:'/editMan/:guanId',component:editMan ,name:'editMan',meta: {keepAlive:false}},
        {path:'/editLife/:guanId',component:editLife,name:'editLife',meta: {keepAlive:false}},
        {path:'/editLifeTree/:guanId',component:editLifeTree,name:'editLifeTree',meta: {keepAlive:false}},
        {path:'/editPassword/:guanId',component:editPassword ,name:'editPassword',meta: {keepAlive:false}},
        {path:'/editAdmin/:guanId',component:editAdmin ,name:'editAdmin',meta: {keepAlive:false}},
        {path:'/editAdminDetails/:guanId',component:editAdminDetails ,name:'editAdminDetails',meta: {keepAlive:false}},
        {path:'/changeAdminDetails/:guanId',component:changeAdminDetails ,name:'changeAdminDetails',meta: {keepAlive:false}},
        {path:'/familyTreeAdd/:uid/:rel',component:familyTreeAdd ,name:'familyTreeAdd',meta: {keepAlive:false}},
        {path:'/selectSkin',component:selectSkin ,name:'selectSkin',meta: {keepAlive:false}},

        {path:'/login',component:login ,name:'login',meta: {keepAlive:false}},
        {path:'/register',component:register,name:'register' ,meta: {keepAlive:false}},
        {path:'/forgetPassword',component:forgetPassword,name:'forgetPassword',meta: {keepAlive:false}},
        {path:'/photoLogin',component:photoLogin ,name:'photoLogin',meta: {keepAlive:false}},
        {path:'/protocol',component:protocol ,name:'protocol',meta: {keepAlive:false}},

        // {path:'/loginTest',component:loginTest ,name:'loginTest',meta: {keepAlive:false}},
        {path:'/loginBinding/:oid',component:loginBinding ,name:'loginBinding',meta: {keepAlive:false}},

        {path:'/my',component:my,name:'my',meta: {keepAlive:false}},
        {path:'/settings',component:settings ,name:'settings',meta: {keepAlive:false}},
        {path:'/passwordBinding',component:passwordBinding ,name:'passwordBinding',meta: {keepAlive:false}},
        {path:'/settingDetails/:flag',component:settingDetails ,name:'settingDetails',meta: {keepAlive:false}},
        {path:'/centerMessage',component:centerMessage,name:'centerMessage',meta: {keepAlive:false}},
        {path:'/myMessage',component:myMessage,name:'myMessage',meta: {keepAlive:false}},
        {path:'/answer',component:answer,name:'answer',meta: {keepAlive:false}},
        {path:'/requestManage',component:requestManage,name:'requestManage',meta: {keepAlive:false}},
        {path:'/examineManage',component:examineManage,name:'examineManage',meta: {keepAlive:false}},
        {path:'/toManage/:id/:flag/:userid/:uid',component:toManage,name:'toManage',meta: {keepAlive:false}},
        {path:'/systemMsg',component:systemMsg,name:'systemMsg',meta: {keepAlive:false}},
        {path:'/setfriends',component:setfriends,name:'setfriends',meta: {keepAlive:false}},
        {path:'/srcPage/:sFlag',component:srcPage,name:'srcPage',meta: {keepAlive:false}},
        {path:'/menuPage',component:menuPage,meta: {keepAlive:false}},
        {path:'/editFriend/:fid/:id/:inFlag/:photo/:mobile/:fname/:nicename/:ftypeid',component:editFriend,name:'editFriend',meta: {keepAlive:false}},
        {path:'/attention',component:attention,name:'attention' ,meta: {keepAlive:false}},
        {path:'/jurisdiction',component:jurisdiction,name:'jurisdiction',meta: {keepAlive:false} },
        {path:'/myorder',component:myorder,name:'myorder',meta: {keepAlive:false}},
        {path:'/myArticle',component:myArticle,name:'myArticle',meta: {keepAlive:false}},
        {path:'/goodsDetails/:id',component:goodsDetails,name:'goodsDetails',meta: {keepAlive:false}},
        {path:'/orderEvaluate/:id',component:orderEvaluate,name:'orderEvaluate',meta: {keepAlive:false}},
        {path:'/Invitation',component:Invitation,name:'Invitation',meta: {keepAlive:false}},
        {path:'/feedback',component:feedback,name:'feedback',meta: {keepAlive:false}},
        {path:'/aboutUs',component:aboutUs,meta: {keepAlive:false}},

        {path:'/shopDetails',component:shopDetails,name:'shopDetails',meta: {keepAlive:false}},
        {path:'/cemeteryStore',component:cemeteryStore,name:'cemeteryStore',meta: {keepAlive:false}},
        {path:'/personDetailsmodelone/:id/:key', component:personDetailsmodelone, name:'personDetailsmodelone',meta: {keepAlive:false}},
        {path:'/customerService/:id/:tid', component:customerService, name:'customerService',meta: {keepAlive:false}},
        {path:'/manyperson/:id', component:manyperson, name:'manyperson',meta: {keepAlive:false}},
        {path:'/personDetailsmodelselect/:makeid/:key', component:personDetailsmodelselect, name:'personDetailsmodelselect',meta: {keepAlive:false}},
        {path:'/themes',component:themes,name:'themes',meta: {keepAlive:false}},
        {path:'/tes',component:tes,name:'tes',meta: {keepAlive:false}},

        {path:'/seaBurial/:id',component:seaBurial,name:'seaBurial',meta: {keepAlive:false}},
        {path:'/seaService/:id',component:seaService,name:'seaService',meta: {keepAlive:false}},
        {path:'/seaQuestion/:id',component:seaQuestion,name:'seaQuestion',meta: {keepAlive:false}},
        {path:'/seaMessage/:id',component:seaMessage,name:'seaMessage',meta: {keepAlive:false}},
        {path:'/seaNews/:id',component:seaNews,name:'seaNews',meta: {keepAlive:false}},
        {path:'/seaNewsDetails/:nid',component:seaNewsDetails,name:'seaNewsDetails',meta: {keepAlive:false}},
        {path:'/seaLeaveMsg/:nid',component:seaLeaveMsg,name:'seaLeaveMsg',meta: {keepAlive:false}},
        {path:'/seaGift/:id',component:seaGift,name:'seaGift',meta: {keepAlive:false}},
        {path:'/seaPhotoList/:id',component:seaPhotoList,name:'seaPhotoList',meta: {keepAlive:false}},
        {path:'/seaPhoto/:id',component:seaPhoto,name:'seaPhoto',meta: {keepAlive:false}},
        {path:'/OperationManual',component:OperationManual,name:'OperationManual',meta: {keepAlive:false}}
    ]
})



// WEBPACK FOOTER //
// ./src/router/index.js